import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const getFillProviders = () => {
  const request = axios.get('/FillProviders').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};
